import { render } from "./Filesystem.vue?vue&type=template&id=32b10518&scoped=true"
import script from "./Filesystem.vue?vue&type=script&lang=js"
export * from "./Filesystem.vue?vue&type=script&lang=js"

import "./Filesystem.vue?vue&type=style&index=0&id=32b10518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b10518"]])

export default __exports__